import { CardCarousel } from '@iheartjane/menu';
import { Box } from '@iheartjane/reefer';

import { DEFAULT_DESKTOP_CARD_WIDTH } from '@jane/shared-ecomm/util';
import {
  CarouselListSkeleton,
  DEFAULT_MOBILE_CAROUSEL_CARD_WIDTH,
  MENU_PRODUCT_ITEM_HEIGHT,
  MENU_PRODUCT_MOBILE_ITEM_HEIGHT,
} from '@jane/shared/components';

import { ListViewCarousel } from './listViewCarousel';
import type { MenuProductCarouselProps } from './menuProductCarousel.types';

/**
 * This component uses CardCarousel under the hood. Children elements should be wrapped in CardCarousel.Card for correct styling
 */

export const MenuProductCarousel = ({
  buttonAriaLabel,
  children,
  cardRef,
  isLoading,
  listView,
  minHeight = 376,
  mode = 'fixed',
  name,
  onHover,
  onLeave,
  subtitle,
  variant = 'default',
  viewAllOnClick,
  viewAllTo,
  ...props
}: MenuProductCarouselProps) => {
  const isAd = variant === 'sponsored' || variant === 'sponsored-inline';
  if (listView) {
    return isLoading ? (
      <CarouselListSkeleton />
    ) : (
      <ListViewCarousel
        name={name}
        onHover={onHover}
        onLeave={onLeave}
        variant={variant}
        viewAllTo={viewAllTo}
        viewAllOnClick={viewAllOnClick}
        {...props}
      >
        {children}
      </ListViewCarousel>
    );
  }

  return (
    <Box
      ariaLabel={isAd ? 'Sponsored content' : name}
      border={
        variant === 'sponsored-inline' ? 'transparent-black-ten' : undefined
      }
      borderWidth={variant === 'sponsored-inline' ? '0 0 1px 0' : undefined}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
      {...props}
    >
      <CardCarousel
        ref={cardRef}
        cardGap={24}
        cardGapMobile={16}
        cardHeight={MENU_PRODUCT_ITEM_HEIGHT}
        cardHeightMobile={MENU_PRODUCT_MOBILE_ITEM_HEIGHT}
        cardWidth={DEFAULT_DESKTOP_CARD_WIDTH}
        cardWidthMobile={DEFAULT_MOBILE_CAROUSEL_CARD_WIDTH}
        headingAs={variant.includes('sponsored') ? 'p' : undefined}
        mode={mode}
        name={name}
        buttonAriaLabel={buttonAriaLabel}
        buttonTo={viewAllTo}
        buttonOnClick={viewAllOnClick}
        minHeight={minHeight}
        isLoading={isLoading}
        subtitle={subtitle}
        surtitle={variant.includes('sponsored') ? 'Sponsored' : undefined}
      >
        {children}
      </CardCarousel>
    </Box>
  );
};
